export default function storeId() {
  const tag = document.querySelector('meta[property="store_id"]');
  return tag && tag.getAttribute('content');
}
